<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          i Administración
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .col-12.d-grid.row.flex-row.align-items-start.mt-4
        .card.p-0.ad_border2-primaryLight.rounded-xl
          .card-body.py-5
            .justify-content-around
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-4.font-1em.font-weight-bold(@click="goTo('/administracion/id/kpi-adherencia')") Administrar Kpi Adherencia
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-5.font-1em.font-weight-bold(@click="goTo('/administracion/id/kpi-negocio')") Administrar Kpi Negocio
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-5.font-1em.font-weight-bold(@click="goTo('/administracion/id/role')") Administrar Rol
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-5.font-1em.font-weight-bold(@click="goTo('/administracion/id/profile')") Administrar Perfiles
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-5.font-1em.font-weight-bold(@click="goTo('/administracion/id/scale-values-list')") Administrar Escala Valores
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-5.font-1em.font-weight-bold(@click="goTo('/administracion/id/categoryexts-list')") Administrar Competencias
              .col-12.row.pad
                div(v-show="userinfo.isAdminOfUsers")
                  a.btn.btn-secondary.py-3.px-5.font-1em.font-weight-bold(@click="goTo('/administracion/id/guideline-list')") Administrar Conductas
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AdministracionHome',

  data () {
    return {
      userinfo: {
        name: null,
        profile: {
          name: null
        }
      }
    }
  },
  methods: {
    goTo (namepath) {
      this.$router.replace({path: namepath, query: {restart: true}})
    }
  },
  mounted () {
    this.userinfo = this.$store.getters['auth/getUserInfo'] 
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-home.vue